import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProductsForm from "components/products/ProductsForm";
import { useProducts } from "components/products/hooks/useProducts";
import Alert from "components/common/Alert";

export default function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadProductById, editProduct } = useProducts();

  const [initialData, setInitialData] = useState(null);
  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";

  useEffect(() => {
  const fetchProduct = async () => {
    try {
      const res = await loadProductById(id);
      setInitialData(res.data);
    } catch (err) {
      setAlert({
        type: "error",
        message: "Failed to load product",
      });
    }
  };

  fetchProduct();
}, [id]);


  if (!initialData) return <p className="p-6">Loading...</p>;

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <ProductsForm
        initialData={initialData}
        onSubmit={async (fd) => {
          try {
            fd.append("updated_by", userId);
            await editProduct(id, fd); 
            navigate("/admin/products");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Failed to update product",
            });
          }
        }}
        onBack={() => navigate("/admin/products")}
        submitLabel="Update Product"
      />
    </>
  );
}
